// Scenario 4a: cancelled_grace_expired
// Same tenant as cancelled_grace_period_gb but currentPeriodEnd is in the past
// and status = 'canceled'. Reactivate routes through signup (see #05).

import { cancelledGracePeriodGb } from './cancelled-grace-period-gb.fixture';
import { Scenario, daysFromNow } from './scenario.types';

export const cancelledGraceExpired: Scenario = {
  ...cancelledGracePeriodGb,
  name: 'cancelled_grace_expired',
  subscription: cancelledGracePeriodGb.subscription
    ? {
        ...cancelledGracePeriodGb.subscription,
        id: 'sub_cancelled_grace_expired',
        status: 'canceled',
        currentPeriodEnd: daysFromNow(-3)
      }
    : null
};
